import React from 'react';
import Shimmer from 'sushiweb/Shimmer';

const LoadingUI = () => {
  return (
    <div className='tw-px-5 tw-w-full tw-flex tw-flex-col tw-gap-4 tw-pt-5'>
      {[...Array(8)].map((_, index) => (
        <div className='tw-rounded-lg tw-overflow-hidden' key={index}>
          <Shimmer height='5rem' width='100%' />
        </div>
      ))}
    </div>
  );
};

export default LoadingUI;
